import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FetchCompanySettings } from "../features/slice";
import { FetchSubAdminsDetails } from "../features/subAdmin/SubAdminSlice";

function ProtectedRoute({ children, requireEvents, requireMembership, superAdminOnly }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const companySettings = useSelector((store) => store.main.companySettings);
  const id = useSelector((store) => store.main.id);
  const userDetails = useSelector((store) => store.subAdmin.detail);

  useEffect(() => {
    if (id && Object.keys(companySettings || {}).length === 0) {
      dispatch(FetchCompanySettings());
    }
  }, [dispatch, id, companySettings]);

  // Check if route requires super admin only access
  if (superAdminOnly) {
    // Only allow access if user is super admin (is_company = false/0)
    if (userDetails?.is_company) {
      return <Navigate to="/dashboard" replace />;
    }
    // Super admin has access, continue to other checks
  }

  // Super admins (is_company = false/0) have full access - skip all route protection
  if (!userDetails?.is_company) {
    return children;
  }

  // Only block access if settings are loaded AND the feature is explicitly disabled
  // If settings haven't loaded yet, allow access (don't block the page)
  if (companySettings && Object.keys(companySettings).length > 0) {
    // Check if events are required but not enabled
    if (requireEvents && companySettings?.events !== true) {
      return <Navigate to="/dashboard" replace />;
    }

    // Check if membership is required but not enabled
    if (requireMembership && companySettings?.membership !== true) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
